import { reduce } from 'lodash';
import { ActionType } from './index';
import { IAppState } from '../reducers/index'
import { SeatingOptionGroup } from '../classes/seating-option'
import { ISeatMatchRequestModel } from '../classes/request-model';
import { getCurrentLanguage } from '../helpers/window-helpers';
import { saveSeatRequest, clearAllSeatRequests } from '../helpers/local-storage-helpers';


export interface ISeatInCartRequestModel {
    seatNumber: number;
    itemId: number;
    seatId: string;
    brandId: string;
}

export function createFilterRequest(currentState: IAppState) {

    let seatMatchRequest: ISeatMatchRequestModel = {
        brandId: currentState.appSettingsModel.brandId,
        minPrice: currentState.priceRangeModel.minPrice,
        maxPrice: currentState.priceRangeModel.maxPrice,
        allowSeparatedSeats: false, //disabled until SmartSeat can actually support this
        itemId: currentState.appSettingsModel.itemId,
        itemType: currentState.appSettingsModel.itemType,
        requestedPriceTypes: currentState.priceTypesModel.priceTypes.map(priceType => {
            return {
                priceTypeId: priceType.priceTypeId,
                quantity: priceType.selectedQuantity
            }
        }),
        selectedVenueLevels: currentState.venueLevelModel.venueLevels.filter(level => { return level.selected }).map(level => { return level.levelNumber }),
        allowAisleAccessSelected: currentState.additionalSeatingOptionModel.allowAisleAccessSelected,
        additionalSeatingOptions: currentState.additionalSeatingOptionModel.additionalSeatingOptions
            .map(additionalSeatingOption => {

                let selectedSeatingOptionIds = additionalSeatingOption.options.filter(seatingOption => {
                    return seatingOption.selected == true;
                }).map(seatingOption => {
                    return seatingOption.id;
                });

                const option = {
                    ...{},
                    seatingOptionGroupId: additionalSeatingOption.id,
                    numberRequested: additionalSeatingOption.groupSeatSelectedQuantity,
                    selectedSeatingOptionIds: selectedSeatingOptionIds,
                    groupSelected: additionalSeatingOption.groupSelected
                } as any;

                return option;
            }),
        additionalNotes: currentState.additionalSeatingOptionModel.additionalNotes,
        language: getCurrentLanguage()        
    };
    const appSettings = currentState.appSettingsModel;
    try {
        saveSeatRequest(appSettings.itemId, appSettings.itemType, JSON.stringify(seatMatchRequest));
    } catch (exception) {
        clearAllSeatRequests();
        console.log("LOG: LocalStorage is full (saving for item " + appSettings.itemId.toString());
    }
    return seatMatchRequest;
}